/* global window */

import log from 'loglevel';

const settings = {
  defaultLogLevel: log.levels.DEBUG,
  timeout: 5000,
  sessionLength: 1000 * 60 * 30,

  braze: {
    scripts: [
      'https://assets.htvapps.com/metaphor/latest/appboy.min.25f9513.js',
    ],
    enableHtmlInAppMessages: true,
    allowUserSuppliedJavascript: true,
  },

  ...window.METAPHOR_SETTINGS,
};

export default settings;



// WEBPACK FOOTER //
// ./src/settings.js